module.exports = __webpack_public_path__ + "img/16.cfd7c85a.jpg";